module.exports = __webpack_public_path__ + "0ade459b5cbb39fd979fa7589f19c36b.svg";